/**
 * Sales — one page for every scope.
 *
 * National ticket sales, or one region's, as the address says.
 *
 * The two bodies are the pages that used to live under `/admin/sales` and
 * `/r/:regionSlug/sales`. Neither has changed: at national scope this calls
 * the `/dashboards/admin/…` endpoint the admin page called, and at regional
 * scope the `/dashboards/regional/:slug/…` endpoint the regional page called,
 * so the numbers are the same numbers. What is gone is the second URL tree and
 * the second copy of the chrome around them.
 */
import { DashboardsPage } from '../DashboardsPage';
import { RegionalSales } from '../regional/RegionalSales';

import AdminSales from './AdminSales';
import { useDashboardScope } from './dashboard-scope';
import { DashboardScopeHeader } from './DashboardScopeHeader';
import { ScopedDashboardBody } from './ScopedDashboardBody';

export default function SalesPage() {
  const scope = useDashboardScope();

  return (
    <DashboardsPage
      header={<DashboardScopeHeader title="Sales" basePath="/admin/sales" scope={scope} />}
    >
      <ScopedDashboardBody
        scope={scope}
        national={<AdminSales />}
        regional={(regionSlug) => <RegionalSales regionSlug={regionSlug} />}
      />
    </DashboardsPage>
  );
}
